export default "__VITE_ASSET__Bxwnf9ky__"